import { http } from "@/api/common";

export default {
  async searchUsers(idToken, query) {
    return await http.get(`/google/users?q=${query}`, undefined, {
      headers: { Authorization: `Bearer ${idToken}` },
    });
  },

  async searchGroups(idToken, query) {
    return await http.get(`/google/groups?q=${query}`, undefined, {
      headers: { Authorization: `Bearer ${idToken}` },
    });
  },
};
